export default "__VITE_ASSET__a86fd324__"